export class GeneralUtil {

    constructor() {}

    getNameInitials = function(name){
        let final_name = ''

        if (name !== undefined && name != null) {
            const names = name.split(' ');
            if (names.length >= 2) {
                if (names[0][0] !== undefined) {
                    final_name = names[0][0].toUpperCase();
                }
                if (names[names.length - 1][0] !== undefined) {
                    final_name = final_name + names[names.length - 1][0].toUpperCase()
                }
                return final_name;
            } else {
                return names[0][0];
            }
        } else {
            return '';
        }
    };
}


